export const WaitlistForm = {
  flow: 'column',
  gap: 'B1',
  flex: '1',
  childProps: {
    value: (el, s) => s[el.key.toLowerCase()],
    fontSize: 'A2',
    padding: 'Z1 A2',
    width: '100%',
    maxWidth: 'G',
    onChange: (ev, el, s) => {
      s.update({
        [el.key.toLowerCase()]: el.node.value
      })
    }
  },
  childExtends: 'Input',
  Name: {
    placeholder: (el) => el.call('polyglot', 'auth.waitlist.namePlaceholder'),
    required: true
  },
  Email: {
    placeholder: (el) => el.call('polyglot', 'auth.waitlist.emailPlaceholder'),
    required: true,
    type: 'email'
  }
}
